module.exports = __webpack_public_path__ + "images/warehouse3.6d485a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/warehouse3.jpg
// module id = 645
// module chunks = 0